import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-center no_node_selected bg-bg-medium select-none"
}
const _hoisted_2 = { class: "cell auto panels_container" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "h-2 bg-black" }, null, -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EmptyState = _resolveComponent("EmptyState")!
  const _component_Params = _resolveComponent("Params")!

  return (_openBlock(), _createElementBlock("div", {
    class: "Panel ParamsStack h-full max-h-full overflow-y-scroll grid-y bg-bg-medium text-text styled-scroll-bar",
    onPointermove: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.on_pointer_move && _ctx.on_pointer_move(...args)))
  }, [
    (_ctx.validStackItems.length == 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_EmptyState, {
            displayEmoji: false,
            title: "Parameters Stack",
            subtitle: "Display multiple node parameters at the same time"
          })
        ]))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.validStackItems, (validStackItem, i) => {
        return (_openBlock(), _createElementBlock("div", {
          ref_for: true,
          ref: "paramsStackItem",
          class: _normalizeClass(['border-l-4', _ctx.selectedStates[i] ? 'border-green-500' : 'border-transparent'])
        }, [
          (_openBlock(), _createBlock(_component_Params, {
            nodeId: validStackItem.nodeId,
            key: validStackItem.nodeId,
            expanded: validStackItem.expanded,
            overflowYAuto: false,
            displayCloseButton: true,
            displayGoToNodeButton: true,
            expandable: true,
            moveableUp: _ctx.moveableStates[i].up,
            moveableDown: _ctx.moveableStates[i].down,
            onClose: ($event: any) => (_ctx.removeCurrentNodeIdFromIndex(i)),
            onGoToNode: ($event: any) => (_ctx.goToNode(i)),
            onToggleExpanded: ($event: any) => (_ctx.toggleExpanded(i)),
            onMoveUp: ($event: any) => (_ctx.moveUp(i)),
            onMoveDown: ($event: any) => (_ctx.moveDown(i))
          }, null, 8 /* PROPS */, ["nodeId", "expanded", "moveableUp", "moveableDown", "onClose", "onGoToNode", "onToggleExpanded", "onMoveUp", "onMoveDown"])),
          _hoisted_3
        ], 2 /* CLASS */))
      }), 256 /* UNKEYED_FRAGMENT */))
    ])
  ], 32 /* HYDRATE_EVENTS */))
}